// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-editor/" + (chunkId === 4061 ? "post-actions" : chunkId) + ".chunk.min.css";
};